import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, switchMap } from 'rxjs';

import { BaseService } from './base-service';
import { DeleteStorageObject$Params } from '../api/backend-connector/fn/storage-objects/delete-storage-object';
import { DownloadFile$Params } from '../api/backend-connector/fn/storage-objects/download-file';
import { GetStorageObject$Params } from '../api/backend-connector/fn/storage-objects/get-storage-object';
import { ListStorageObjects$Params } from '../api/backend-connector/fn/storage-objects/list-storage-objects';
import { UpdateStorageObject$Params } from '../api/backend-connector/fn/storage-objects/update-storage-object';
import { UploadFile$Params } from '../api/backend-connector/fn/storage-objects/upload-file';
import { StorageObjectsApi } from '../api/backend-connector/services';
import { GetStorageObjectUrl$Params } from '@api/backend-connector/fn/storage-objects/get-storage-object-url';
import { UpdateBulkStorageObjectRequest } from '@api/backend-connector/models';

const toasts = {
  createSuccessSummary: 'i18n.AttachmentToast.createSuccessSummary',
  createSuccessDetail: 'i18n.AttachmentToast.createSuccessDetail',
  createFailSummary: 'i18n.AttachmentToast.createFailSummary',
  createFailDetail: 'i18n.AttachmentToast.createFailDetail',

  updateSuccessSummary: 'i18n.Toast.updateSuccessSummary',
  updateSuccessDetail: 'i18n.Toast.updateSuccessDetail',
  updateFailSummary: 'i18n.Toast.updateFailSummary',
  updateFailDetail: 'i18n.Toast.updateFailDetail',

  deleteSuccessSummary: 'i18n.AttachmentToast.deleteSuccessSummary',
  deleteSuccessDetail: 'i18n.AttachmentToast.deleteSuccessDetail',
  deleteFailSummary: 'i18n.AttachmentToast.deleteFailSummary',
  deleteFailDetail: 'i18n.AttachmentToast.deleteFailDetail',
};

@Injectable({
  providedIn: 'root',
})
export class AttachmentsService extends BaseService {
  private readonly storageObjectsService = inject(StorageObjectsApi);
  readonly toasts = toasts;

  readonly refresh$ = new BehaviorSubject<void>(undefined);

  getAttachment(params: GetStorageObject$Params) {
    return this.storageObjectsService.getStorageObject(params);
  }

  listStorageObjects(params: ListStorageObjects$Params) {
    return this.refresh$.pipe(switchMap(() => this.storageObjectsService.listStorageObjects(params)));
  }

  updateAttachment(params: UpdateStorageObject$Params) {
    return this.storageObjectsService.updateStorageObject(params);
  }

  updateBulkAttachment(assetId: string, request: UpdateBulkStorageObjectRequest) {
    return this.storageObjectsService.updateBulkStorageObject({ assetId, body: request });
  }

  deleteAttachment(params: DeleteStorageObject$Params) {
    return this.storageObjectsService.deleteStorageObject(params);
  }

  getAttachmentUrl(params: GetStorageObjectUrl$Params) {
    return this.refresh$.pipe(switchMap(() => this.storageObjectsService.getStorageObjectUrl(params)));
  }

  uploadFile(params: UploadFile$Params) {
    return this.storageObjectsService.uploadFile(params);
  }

  downloadFile(params: DownloadFile$Params) {
    return this.storageObjectsService.downloadFile(params);
  }
}
